import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { jsxActions as slittingGridActions }       from '../../actions/LocationPage/SlittingView/slittingGridActions';
import { jsxActions as slittingViewActions }       from '../../actions/LocationPage/SlittingView/slittingViewActions.js';
import { jsxActions as slitRollsToCassettesActions }       from '../../actions/Dialogs/SlitRollsToCassettesDialog/slitRollsToCassettesDialogActions.js';
import { jsxActions as locationPageActions }      from '../../actions/LocationPage/locationPageActions';
import { jsxActions as fetchEntitiesActions } from '../../actions/FetchEntities/fetchEntitiesActions.js';
import { jsxActions as headerActions }   from '../../actions/Header/headerActions';
import {gridsNames} from '../../enums/gridsNames';
import SlittingView from '../../components/LocationPage/SlittingView/slittingView.js';
import {List} from 'immutable';

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      slittingGridActions:  bindActionCreators(slittingGridActions, dispatch),
      slittingViewActions:    bindActionCreators(slittingViewActions, dispatch),
      slitRollsToCassettesActions:    bindActionCreators(slitRollsToCassettesActions, dispatch),
      locationPageActions:       bindActionCreators(locationPageActions, dispatch),
      fetchEntitiesActions:    bindActionCreators(fetchEntitiesActions, dispatch),
      headerActions: bindActionCreators(headerActions, dispatch),
    }
  }
}

let SlittingViewContainer = connect(
  (state) => {
    let grid = state.grid.get(gridsNames.LOCATION_SLITTING) ? state.grid.get(gridsNames.LOCATION_SLITTING) : null;
    return {
      sSelectedRowsData: grid?.get('selectedRowsData') || List(),
      sSlitRollsToCassettesData : state.dialogs.get('slitRollsToCassettesData'),

    };
  },
  mapDispatchToProps
)(SlittingView);

export default SlittingViewContainer;




